import { Component, Input, OnInit } from '@angular/core';
import { BrowseComponent } from '@shared/components/browse/abstract.browse.component';
import { Pagination } from '@core/bean/pagination';
import { CommonsService } from '@core/service/commons.service';
import { NzModalService } from 'ng-zorro-antd';
import { JyUserService } from '../../../../routes/jy-authorization/user/jy-user.service';
import { HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { BrowseConfig } from '@core/bean/browse-config';


/**
 * 用户浏览按钮
 */
@Component({
  selector: 'user-browse',
  templateUrl: './user.browse.component.html'
})
export class UserBrowseComponent implements BrowseComponent, OnInit {

  static componentName='UserBrowseComponent';

  @Input() config: BrowseConfig;
  @Input() onOk: (data: any | [any]) => void;
  @Input() onCancel: () => void;

  visible = false;
  pagination: Pagination = new Pagination();

  constructor(
    private commonsService: CommonsService,
    private modalService: NzModalService,
    private jyUserService: JyUserService
  ) {
    this.pagination.getData = function (params: HttpParams): Observable<any> {
      return jyUserService.query(params);
    }
  }


  ngOnInit() {
    if (!this.config.multiple) {
      this.pagination.multipleCheck = false;
    }
    this.getData();
    this.visible = true;
  }

  getData() {
    this.pagination.toFirstPage();
  }

  modalOk() {
    let result = this.pagination.selectedRows;
    if (!this.config.multiple) {
      result = result.length > 0 ? result[0] : null;
      if (result) {
        this.onOk(result);
        this.visible = false;
      } else {
        this.commonsService.showWarningMessage("commons.info.selectData");
      }
    } else {
      if (result.length > 0) {
        this.onOk(result);
        this.visible = false;
      } else {
        this.commonsService.showWarningMessage("commons.info.selectData");
      }
    }
  }


  selectData(data) {
    let result = [data];
    if (!this.config.multiple) {
      result = result.length > 0 ? result[0] : null;
      if (result) {
        this.onOk(result);
        this.visible = false;
      } else {
        this.commonsService.showWarningMessage('commons.info.selectData');
      }
    } else {
      if (result.length > 0) {
        this.onOk(result);
        this.visible = false;
      } else {
        this.commonsService.showWarningMessage('commons.info.selectData');
      }
    }
  }

  modalCancel() {
    this.visible = false;
    this.onCancel();
  }
}
